import { render } from "./RecurrencePatternWeekdaysCheckboxes.vue?vue&type=template&id=b0dbe3ec"
import script from "./RecurrencePatternWeekdaysCheckboxes.vue?vue&type=script&lang=ts"
export * from "./RecurrencePatternWeekdaysCheckboxes.vue?vue&type=script&lang=ts"
script.render = render

export default script